// removed by extract-text-webpack-plugin
module.exports = {"mainWrapper":"mainWrapper__35zRe","filterSectionAction":"filterSectionAction__2Jvge"};


//////////////////
// WEBPACK FOOTER
// ./components/EmbedSection/style.scss
// module id = sw42
// module chunks = 0